
export const changeRequestsLocalization = {
  mainHeading: {
    en: 'Your change requests',
    nb: 'Dine endringssøknader',
    nn: 'Dine endringssøknader',
  },
  mainParagraph1: {
    en: 'Here you will find all change requests related to',
    nb: 'Her ser du alle endringssøknader knyttet til',
    nn: 'Her kan du sjå alle endringsførespurnader knytte til',
  },
  mainParagraph2: {
    en: 'If the application has been registered by mail, email, or phone, it may take some time before it becomes visible here.',
    nb: 'Hvis søknaden har blitt registrert via post, e-post eller telefon kan det ta litt tid før den blir synlig her.',
    nn: 'Dersom søknaden har vorte registrert via post, e-post eller telefon, kan det ta litt tid før den blir synleg her.',
  },
  draftItemsHeading: {
    en: 'Drafts',
    nb: 'Utkast',
    nn: 'Utkast',
  },
  draftDeleteParagraph: {
    en: 'Drafts are saved for 90 days after the last change.',
    nb: 'Utkast lagres i 90 dager etter siste endring.',
    nn: 'Utkast blir lagra i 90 dagar etter siste endring.',
  },
  draftItemsEmpty: {
    en: 'You have no drafts',
    nb: 'Du har ingen utkast.',
    nn: 'Du har ingen utkast.',
  },
  submittedItemsHeading: {
    en: 'Submitted',
    nb: 'Innsendte',
    nn: 'Innsendte',
  },
  submittedItemsEmpty: {
    en: 'You have no cases under consideration.',
    nb: 'Du har ingen saker under behandling.',
    nn: 'Du har ingen saker under behandling.',
  },
  closedItemsHeading: {
    en: 'Closed',
    nb: 'Avsluttede',
    nn: 'Avslutta',
  },
  closedItemsEmpty: {
    en: 'You have no processed cases.',
    nb: 'Du har ingen ferdig behandlede saker.',
    nn: 'Du har ingen ferdigbehandla saker.',
  },
  lastModifiedOn: {
    en: 'Last changed',
    nb: 'Sist endret',
    nn: 'Sist endra',
  },
  submittedOn: {
    en: 'Submitted',
    nb: 'Innsendt',
    nn: 'Innsendt',
  },
  tasks: {
    en: 'tasks',
    nb: 'oppgaver',
    nn: 'oppgavar',
  },
  task: {
    en: 'task',
    nb: 'oppgave',
    nn: 'oppgave',
  },
  Rejected: {
    en: 'Rejected',
    nb: 'Avslått',
    nn: 'Avslått',
  },
  Approved: {
    en: 'Approved',
    nb: 'Innvilget',
    nn: 'Innvilga',
  },
  Withdrawn: {
    en: 'Withdrawn',
    nb: 'Trukket',
    nn: 'Trekt',
  },
  Draft: {
    en: 'Draft',
    nb: 'Utkast',
    nn: 'Utkast',
  },
  Unallocated: {
    en: 'Submitted',
    nb: 'Innsendt',
    nn: 'Innsendt',
  },
  UnderConsideration: {
    en: 'Submitted',
    nb: 'Innsendt',
    nn: 'Innsendt',
  },
  MissingInformation: {
    en: 'Submitted',
    nb: 'Innsendt',
    nn: 'Innsendt',
  },
  'application-maintenance-amortization-delay': {
    en: 'Installment deferral',
    nb: 'Avdragsutsettelse',
    nn: 'Avdragsutsetjing',
  },
  'maintenance-amortization-delay': {
    en: 'Installment deferral',
    nb: 'Avdragsutsettelse',
    nn: 'Avdragsutsetjing',
  },
  'amortization-delay': {
    en: 'Installment deferral',
    nb: 'Avdragsutsettelse',
    nn: 'Avdragsutsetjing',
  },
  'maintenance-priority-deviation': {
    en: 'Priority violation',
    nb: 'Prioritetsvikelse',
    nn: 'Prioritetsvikelse',
  },
  'maintenance-release-of-collateral': {
    en: 'Waiver of securities',
    nb: 'Frafall av sikkerheter',
    nn: 'Bortfall av tryggleikar',
  },
  'release-of-collateral': {
    en: 'Waiver of securities',
    nb: 'Frafall av sikkerheter',
    nn: 'Bortfall av tryggleikar',
  },
  'maintenance-extend-of-collateral': {
    en: 'Extension of securities',
    nb: 'Utvidelse av sikkerheter',
    nn: 'Utviding av tryggingsstillelser',
  },
  'maintenance-consent': {
    en: 'Consent',
    nb: 'Samtykke',
    nn: 'Samtykke',
  },
  'maintenance-amendment-of-terms': {
    en: 'Amendment of terms',
    nb: 'Endring av vilkår på lån/tilskudd',
    nn: 'Endring av vilkår på lån/tilskot',
  },
  'maintenance-consolidation-of-loans': {
    en: 'Consolidation of loans',
    nb: 'Sammenslåing av lån',
    nn: 'Samanslåing av lån',
  },
  'maintenance-payment-deferral': {
    en: 'Payment deferral for up to 6 months',
    nb: 'Betalingsutsettelse inntil 6 måneder',
    nn: 'Betalingsutsetjing inntil 6 månader',
  },
  'deferral-payment': {
    en: 'Payment deferral for up to 3 months',
    nb: 'Betalingsutsettelse inntil 3 måneder',
    nn: 'Betalingsutsetjing inntil 3 månader',
  },
  'maintenance-accumulate-interest': {
    en: 'Accumulate interest',
    nb: 'Renteakkumulering',
    nn: 'Renteakkumulering',
  },
  'maintenance-interest-free-period': {
    en: 'Interest waiver',
    nb: 'Rentefritak',
    nn: 'Rentefritak',
  },
  'maintenance-remission-of-debt': {
    en: 'Debt forgiveness',
    nb: 'Gjeldsettergivelse',
    nn: 'Gjeldsettergiving',
  },
  'maintenance-change-of-debtor': {
    en: 'Change of debtor',
    nb: 'Debitorskifte',
    nn: 'Debitorskifte',
  },
  applyForChangeHeading: {
    en: 'Apply for a deferral or change of terms',
    nb: 'Søk om utsettelse eller endring av vilkår',
    nn: 'Søk om utsetjing eller endring av vilkår',
  },
  applyForChangeParagraph: {
    en: 'If you need changes to your loan terms or collateral for one or more loans, you can apply for a change here. You can also apply for a payment deferral or installment deferral.',
    nb: 'Har du behov for endringer i lånevilkår eller sikkerheter knyttet til et eller flere lån, kan du søke om endring her. Du kan også søke om betalingsutsettelse eller avdragsutsettelse.',
    nn: 'Har du behov for endringar i lånevilkår eller sikkerheiter knytte til eitt eller fleire lån, kan du søke om endring her. Du kan også søke om betalingsutsetjing eller avdragsutsetjing.',
  },
  applyForChangeLink: {
    en: 'Apply for change',
    nb: 'Søk om endring',
    nn: 'Søk om endring',
  },
} as const;
